import React, { useMemo, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import SwiperCore, { FreeMode, Navigation } from 'swiper'
import { RailItemMain } from '../RailItemMain/RailItemMain'
import { RailItem } from '../RailItem/RailItem'
import {
  CustomSwiper,
  PointingTriangle,
  RailBackground,
  RailTitle,
  Title,
  WatchButton,
} from './MainRailPage.style'
import { ICategoryTreeItem } from '../../../types'
import { useOttOverlay } from '../../../contexts'
import { SeparateRailWrap } from '../ComponentsFactory/ComponentsFactory.style'
import { NextButton, PrevButton } from '../SideButtons/SideButtons'

SwiperCore.use([Navigation, FreeMode])

interface RailProps {
  data: ICategoryTreeItem | null
}

export const MainRailPage: React.FC<RailProps> = ({ data }) => {
  const { rails } = useOttOverlay()
  const [nextButton, setNextButton] = useState<boolean>(true)
  const [prevButton, setPrevButton] = useState<boolean>(false)

  const railItems = useMemo(() => {
    if (rails && rails?.length > 0) {
      return rails[0].child
    }
    return null
  }, [rails])

  if (!railItems) {
    return null
  }

  const swiperConfig = {
    rtl: 'true',
    slidesPerView:
      data?.dynamicData?.component_type?.value === 'main' ? 2.4 : 1.6,
    spaceBetween: data?.dynamicData?.component_type?.value === 'main' ? 11 : 12,
    speed: 1100,
    freeMode: true,
    breakpoints: {
      760: {
        allowTouchMove: false,
        watchSlidesProgress: true,
        slidesPerView:
          data?.dynamicData?.component_type?.value === 'main' ? 6.5 : 5,
        spaceBetween:
          data?.dynamicData?.component_type?.value === 'main' ? 25 : 25,
        slidesPerGroup: 5,
        ...(data?.dynamicData?.component_type?.value !== 'main' && {
          navigation: {
            nextEl: '.swiper-button-next-custom',
            prevEl: '.swiper-button-prev-custom',
          },
        }),
        allowSlidePrev: true,
        allowSlideNext: true,
      },
    },
  }

  const recommendationRail = () => (
    <RailBackground
      data-name={'Recommendation-Rail'}
      desktopImage={
        'https://media3.reshet.tv/image/upload/v1709643070/uploads/2024/903961861.jpg'
      }
      mobileImage={
        'https://media3.reshet.tv/image/upload/c_scale,q_auto:good,w_400/v1707813366/MobileOttBackground_dlhcon.png'
      }
    >
      <Title>רשת 13 שידור חי</Title>
      <WatchButton>
        <PointingTriangle>▶</PointingTriangle> לצפייה
      </WatchButton>
      <Swiper {...swiperConfig}>
        {railItems?.map((r, i) => (
          <SwiperSlide key={r.id}>
            <RailItemMain
              data={r}
              isFirst={i === 0}
              isLast={i === railItems.length - 1}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </RailBackground>
  )
  const showItemTitle = data?.dynamicData.title?.value !== 'false'
  const mainRail = () => (
    <SeparateRailWrap
      programWidth={90}
      showItemTitle={showItemTitle}
      data-name={'main'}
    >
      <div style={{ position: 'relative' }}>
        {data && <RailTitle>{data.name.trim()}</RailTitle>}
        <CustomSwiper
          {...swiperConfig}
          onReachEnd={() => {
            setNextButton(false)
            setPrevButton(true)
          }}
          onReachBeginning={() => {
            setPrevButton(false)
            setNextButton(true)
          }}
        >
          <PrevButton
            prevButton={prevButton}
            toggleNextButton={nextButton => setNextButton(nextButton)}
          />
          {railItems?.map((r, i) => (
            <SwiperSlide key={r.id}>
              <RailItem
                data={r}
                isFirst={i === 0}
                isLast={i === railItems.length - 1}
                showItemTitle={true}
              />
            </SwiperSlide>
          ))}
          <NextButton
            nextButton={nextButton}
            togglePrevButton={prevButton => setPrevButton(prevButton)}
          />
        </CustomSwiper>
      </div>
    </SeparateRailWrap>
  )

  return (
    <>
      {data?.dynamicData?.component_type?.value === 'main'
        ? recommendationRail()
        : mainRail()}
    </>
  )
}
